import ClassNames from 'classnames'
import React from 'react'
import {
  ChartBase
} from './../../base'

export class Chart extends React.PureComponent {
  render () {
    const {
      className,
      modifierName
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      {'is-modifier-name': modifierName}
    )

    return (
      <ChartBase
        {...this.props}
        className={classes}
      />
    )
  }

  static defaultProps = {
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
